import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const GleamcodeLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.gleamcode',
    link: '/code/gleamcode/list',
    icon: 'navigation-link__list-item',
});